import { Alert, Collapse } from 'antd'
import { Button, InputMonth, Typography } from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import _ from 'lodash'
import moment from 'moment'

const currentMonth = moment().format('YYYY-MM')

const CollapseA = ({ data, dataAmounts, setAmounts, onClickDetail }) => {
  const [dataInput, setDataInput] = useState('')
  const { t } = useTranslation()

  const isInvalid = dataInput && dataInput !== 0 && Math.sign(dataInput) !== 1

  return (
    <Collapse style={{ marginTop: 10 }} accordion={true} defaultActiveKey={['0']}>
      {data.map((el, index) => (
        <Collapse.Panel
          key={index}
          header={t('PLANNING_SAC_HEADER_COMBINATION_TITLE', { index: index + 1 })}
          extra={
            <Button.Link
              title="ACTION_OPEN_DETAIL"
              onClick={(e) => {
                e.stopPropagation()
                onClickDetail(index)
              }}
            />
          }
        >
          {isInvalid ? (
            <Alert
              type="warning"
              showIcon
              description={t('PLANNING_SAC_INFORMATIVE_POSITIVE_VALUES_ALERT_DESCRIPTION')}
            />
          ) : null}
          {_.map(dataAmounts[index], (value, date) => {
            return (
              <InputMonth
                index={index}
                month={date}
                defaultValue={value}
                disabled={date < currentMonth}
                min={0}
                style={{ paddingRight: 5 }}
                onChange={(val) => {
                  setAmounts(index, date, val)
                  setDataInput(val)
                }}
              />
            )
          })}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <Typography.Body>{`${t('FIELD_TOTAL')}: ${_.reduce(
              dataAmounts[index],
              (acum, data) => {
                acum = acum + data
                return acum
              },
              0,
            )}`}</Typography.Body>
          </div>
        </Collapse.Panel>
      ))}
    </Collapse>
  )
}

export default CollapseA
